import React, { useContext, useState } from 'react'

import { LocaleContext } from '../locale/i18n'
import { gaEvents } from '../logic/ga4'
import { getMetrics } from '../logic/metrics'
import publicConfig from '../logic/public-config'
import { FormFeedbackState } from '../logic/shared-types'

import Button from './Button'
import IconCircledCheck from './icons/IconCircledCheck'

import './ContactForm.scss'
import './SubscriptionForm.scss'

const SubscriptionFormSubmitted = () => {
  const { t } = useContext(LocaleContext)
  return (
    <div className="subscriptionForm__successRow">
      <IconCircledCheck width={24} height={24} />
      <h3>{t('blogLeadForm.success')}</h3>
    </div>
  )
}

export const SubscriptionForm = ({
  title,
  actionTitle,
  sectionId,
  leadTag,
  pageSlug,
}: {
  title: string
  actionTitle: string
  sectionId: string
  leadTag: string
  pageSlug: string
}) => {
  const { t } = useContext(LocaleContext)

  const { locale } = useContext(LocaleContext)
  const [contactEmail, setContactEmail] = useState('')
  const [feedbackState, setFeedbackState] = useState(FormFeedbackState.NONE)

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = e => {
    e.preventDefault()

    setFeedbackState(FormFeedbackState.LOADING)

    const payload = {
      ...getMetrics(),
      email: contactEmail,
      leadTag,
      pageLocale: locale,
      pageSlug,
      sectionId,
      sectionTitle: title,
    }
    fetch(`${String(publicConfig.apiHost)}/v1/blog-lead-form/submit`, {
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    })
      .then(res => {
        if (res.ok) {
          gaEvents.leadFormSubscribed(leadTag)
          setFeedbackState(FormFeedbackState.SUCCESS)
        } else {
          throw new Error(`Server returned HTTP ${res.status}`)
        }
      })
      .catch(() => setFeedbackState(FormFeedbackState.ERROR))
  }
  return (
    <>
      {feedbackState === FormFeedbackState.SUCCESS ? (
        <SubscriptionFormSubmitted />
      ) : (
        <form onSubmit={handleSubmit} className="subscriptionForm">
          <h3 className="subscriptionForm__title">{title}</h3>
          <div className="subscriptionForm__inputRow">
            <input
              className="subscriptionForm__input inputField"
              disabled={feedbackState === FormFeedbackState.LOADING}
              type="email"
              name="email"
              placeholder={t('blogLeadForm.emailLabel')}
              onChange={e => setContactEmail(e.target.value)}
              required
              value={contactEmail}
            />
            <div className="subscriptionForm__action">
              <Button
                className="h-full w-full self-stretch"
                disabled={feedbackState === FormFeedbackState.LOADING}
                isLoading={feedbackState === FormFeedbackState.LOADING}
                type="submit"
              >
                {actionTitle}
              </Button>
            </div>
          </div>
        </form>
      )}

      {feedbackState === FormFeedbackState.ERROR && (
        <p
          className="contactForm__feedback contactForm__feedback--error"
          role="alert"
        >
          {t('blogLeadForm.error')}
        </p>
      )}
    </>
  )
}
